import { render } from "./delivery-challan-returns.vue?vue&type=template&id=49b579ea&scoped=true"
import script from "./delivery-challan-returns.vue?vue&type=script&lang=js"
export * from "./delivery-challan-returns.vue?vue&type=script&lang=js"

import "./delivery-challan-returns.vue?vue&type=style&index=0&id=49b579ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b579ea"]])

export default __exports__